const MAX_HISTORY = 3;
const STORAGE_KEY = "search_history";

export function saveSearchHistory(value) {
  if (!value?.trim()) return;

  let history = JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];

  // Remove duplicate if exists
  history = history.filter(item => item !== value);

  // If full → remove last inserted item (LIFO)
  if (history.length === MAX_HISTORY) {
    history.pop(); // remove most recent (top of stack)
  }

  // Add new value at beginning
  history.unshift(value);

  localStorage.setItem(STORAGE_KEY, JSON.stringify(history));
  return history;
}
